import { CommonModule } from '@angular/common';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'daas-consulting-list-header',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  templateUrl: './list-header.component.html',
  styleUrl: './list-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListHeaderComponent implements AfterContentInit {
  @Input() title?: string | null = '';
  @Input() subtitle?: string | null = '';
  @Input() showButton = true;
  @Input() buttonTitle = 'Nuevo';
  @Input() buttonColor?: string | null = 'primary';
  @Output() readonly buttonClick: EventEmitter<void> = new EventEmitter<void>();

  hasButtons = false;
  hasIcon = false;
  readonly #elementRef: ElementRef;

  constructor(elementRef: ElementRef) {
    this.#elementRef = elementRef;
  }

  ngAfterContentInit(): void {
    this.hasButtons =
      !!this.#elementRef.nativeElement.querySelector('[buttons]');
    this.hasIcon = !!this.#elementRef.nativeElement.querySelector('[icon]');
  }

  handleClick($event: MouseEvent): void {
    $event.preventDefault();
    this.buttonClick.emit();
  }
}
